import { getCustomisationValue } from "../../EditablePreview";

const NaturalSizeImageBG = (props) => {
    // console.log("NaturalSizeImageBG props:", props);
    const customisationVars = props.node.customisationVars;

    const nodeModules = props.node?.config?.children ?? [];
    let imageBgModule = null;
    for (let i = 0; i < nodeModules.length; i++) {
        if (nodeModules[i].module === 'fill') {
            imageBgModule = nodeModules[i];
            break;
        }
    }
    if (!imageBgModule) {
        return null;
    }
    let typeField = null;
    for (let i = 0; i < imageBgModule?.fields?.length; i++) {
        if (imageBgModule.fields[i].field === 'customisation-module-fill-type') {
            typeField = imageBgModule.fields[i];
            break;
        }
    }
    if (!typeField) {
        return null;
    }
    const imageDataLink = typeField?.["customisation-module-fill-type-image"]?.options?.["customisation-module-fill-type-image-options-image"]?.dataLink ?? null;
    if (!imageDataLink) {
        return null;
    }
    const imageData = getCustomisationValue(customisationVars, imageDataLink, props.index ?? 0, props.visualisationComponentKey ?? null, props.selectedFeatureNode);
    if (!imageData || typeof imageData !== 'object' || !imageData.srcUrl) {
        return null;
    }

    const imageStyle = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%) scale(' + props.previewScale + ')',
    }

    return (
        <img style={imageStyle} src={imageData.srcUrl} alt="Natural Size Background" />
    );
}

export default NaturalSizeImageBG;
